import MediaImage from '@src/components/MediaImage';
import {
  CtaFragment,
  MediaAssetFragment,
  MediaImageFragment
} from '@src/graphql/gql-types';
import React from 'react';
import styles from './ProductPromotionCard.module.scss';
import CTAButton from '@src/components/Button/CTAButton';

interface ProductPromotionCard {
  heading: string;
  description: string;
  image: MediaImageFragment;
  cta: CtaFragment;
  urlLink: string;
  assetLink: MediaAssetFragment;
  optionNumber: number;
}

const ProductPromotionCard: React.FC<ProductPromotionCard> = ({
  heading,
  description,
  image,
  cta,
  optionNumber
}) => {
  return (
    <div className={styles.productPromotionCard}>
      <div className={styles.backgroundWrapper}>
        <div className={styles.backgroundMediaWrapper}>
          <MediaImage {...image} />
        </div>
      </div>
      <div className={styles.headingWrapper}>
        <div>
          <div className={styles.option}>
            <p>Option {optionNumber}</p>
          </div>
          <div className={styles.heading}>
            <p>{heading}</p>
          </div>
          {description && (
            <div className={styles.description}>{description}</div>
          )}
        </div>
        {cta && (
          <div className={styles.cta}>
            <CTAButton
              cta={cta}
              label={cta.label || 'Find out more'}
              boxIcon="right-arrow-alt"
              iconPosition="right"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductPromotionCard;
